import { GAME_POTIONS } from "../constants/potions";
import { getCloverPotionById } from "../constants/cloverPotions";

const FEMALE_CHARACTER_IDS = new Set([
  "melitaea",
  "leontine",
  "loudiana",
  "eurydice",
  "melusine",
  "jingxi",
  "nefertary",
  "zamselly",
]);

export function getQuestCharacterGender(characterId) {
  return FEMALE_CHARACTER_IDS.has(characterId) ? "f" : "m";
}

export function getQuestCharacterPrideWord(characterId) {
  return getQuestCharacterGender(characterId) === "f" ? "fière" : "fier";
}

const gamePotionsById = new Map(GAME_POTIONS.map((potion) => [potion.id, potion]));

export function getQuestRewardPotion(potionId) {
  return gamePotionsById.get(potionId) || getCloverPotionById(potionId) || null;
}

export function buildQuestRewardGemImageUrl(gemId) {
  const publicUrl = process.env.PUBLIC_URL || "";
  return `${publicUrl}/gems/${encodeURIComponent(`${gemId}.png`)}`;
}

export function formatRelicChanceTooltip(percent, { demiLuneActive = false } = {}) {
  if (demiLuneActive) {
    return "Le Philtre de la demi-lune est actif pour cette quête. Probabilité d'obtenir une relique : 50 %.";
  }
  if (percent == null) return "Chance d'obtenir une relique";
  return `Probabilité d'obtenir une relique : ${percent} %`;
}

function getGrantTooltipLabel(grant) {
  if (!grant) return "";
  if (grant.label) return grant.label;
  if (grant.kind === "potion") {
    return getQuestRewardPotion(grant.itemId)?.name || "";
  }
  return "";
}

export function formatQuestRewardClaimedAt(isoString) {
  if (!isoString) return null;

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return null;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} à ${hours}:${minutes}`;
}

export function buildClaimedRewardParts(grants = []) {
  return grants
    .filter((grant) => grant && grant.kind !== "relic")
    .map((grant) => ({
      kind: grant.kind,
      quantity: grant.quantity || 1,
      tooltip: getGrantTooltipLabel(grant),
      grant,
    }));
}

export function collectGrantsFromRewards(rewards) {
  if (Array.isArray(rewards?.grants) && rewards.grants.length > 0) {
    return rewards.grants;
  }

  const grants = [];
  if (rewards?.primary) grants.push(rewards.primary);
  if (rewards?.clover) grants.push(rewards.clover);
  return grants;
}
